var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 482,
    viewBox: "0 0 80 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V142V146V482C0.34632 472.5 10.9091 452 41.039 436C71.188 419.99 80 395.833 80 385.5V146V142V96.5C80 86.1667 71.188 62.0102 41.039 46C10.9091 30 0.34632 9.5 0 0Z",
    fill: "#171818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUnion);
export default __webpack_public_path__ + "static/media/NewUnion.41bc8bd8d8b6bd6bfd4e948f0e0d67c8.svg";
export { ForwardRef as ReactComponent };